import { render } from "./FormInicial.vue?vue&type=template&id=7c8aab59"
import script from "./FormInicial.vue?vue&type=script&lang=js"
export * from "./FormInicial.vue?vue&type=script&lang=js"

import "./FormInicial.vue?vue&type=style&index=0&id=7c8aab59&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__